import client from "./client";
import { deleteUser } from "./helper/userCookie";

export async function login(payload) {
  const response = await client.post("/api/v1/auth/login", payload);
  return response.data;
}

export async function registerUser(payload) {
  const response = await client.post("/api/v1/auth/register", payload);
  return response.data;
}

export async function refreshToken(payload) {
  const response = await client.post("/api/v1/auth/refresh", payload);
  return response.data;
}

export async function logout(payload = {}) {
  const response = await client.post("/api/v1/auth/logout", payload);
  return response.data;
}

export async function loginAsGuest(payload = {}) {
  const response = await client.post("/api/v1/auth/guest", payload);
  return response.data;
}

export function logoutLocal() {
  deleteUser();
}
